export default __webpack_public_path__ + "static/media/usdtlogo1.54275ffd.png";